import { gql } from "@apollo/client";

import { propertyFragment } from "src/graphql/anti-fraud/fragments/PropertyFragment";

export const elementTypeFragment = gql`
  fragment ElementTypeFragment on ElementType {
    name
    code
    properties {
      ...PropertyFragment
    }
    elements {
      code
      name
    }
  }

  ${propertyFragment}
`;
